export const obito = [
  {
    label: 'CPF',
    value: 'cpf'
  },
  {
    label: 'Data de óbito',
    value: 'data_obito'
  },
  {
    label: 'Matricula',
    value: 'matricula'
  },
  {
    label: 'Hora de óbito',
    value: 'hora_obito'
  },
  {
    label: 'Livro, folha, termo e lado do registro',
    value: 'livro',
    array: ['livro', 'folha', 'termo', 'lado']
  },
  {
    label: 'Nº Declaração de Óbito',
    value: 'numero_declaracao_obito'
  },
  {
    label: 'Data do registro',
    value: 'data_registro'
  },
  {
    label: 'Local de ocorrência de óbito',
    value: 'local_ocorrencia_obito'
  },
  {
    label: 'Documento',
    value: 'documentos'
  },
  {
    label: 'Endereço do óbito',
    value: 'endereco_obito'
  },
  {
    label: 'Data de nascimento',
    value: 'data_nascimento'
  },
  {
    label: 'Deixa bens',
    value: 'deixa_bens'
  },
  {
    label: 'Idade',
    value: 'idade'
  },
  {
    label: 'Deixa testamento',
    value: 'deixa_testamento'
  },
  {
    label: 'Estado cívil',
    value: 'estado_civil'
  },
  {
    label: 'Reservista',
    value: 'reservista'
  },
  {
    label: 'Naturalidade (UF e cidade)',
    value: 'naturalidade'
  },
  {
    label: 'Eleitor ativo',
    value: 'eleitor_ativo'
  },
  {
    label: 'Endereço da pessoa falecida',
    value: 'endereco_falecido'
  },
  {
    label: 'Deixa filhos',
    value: 'deixa_filhos'
  }
]

export const nascimento = [
  {
    label: 'CPF',
    value: 'cpf'
  },
  {
    label: 'Matrícula',
    value: 'matricula'
  },
  {
    label: 'Livro, folha, termo e lado do registro',
    value: 'livro',
    array: ['livro', 'folha', 'termo', 'lado']
  },
  {
    label: 'Data do registro',
    value: 'data_registro'
  },
  {
    label: 'Data e Hora Nascimento',
    value: 'data_nascimento',
    array: ['data_nascimento', 'hora_nascimento']
  },
  {
    label: 'Sexo',
    value: 'sexo'
  },
  {
    label: 'DNV',
    value: 'dnv'
  },
  {
    label: 'Local da Ocorrência de Nascimento',
    value: 'local_ocorrencia_nascimento'
  },
  {
    label: 'Endereço de Nascimento',
    value: 'endereco_nascimento'
  },
  {
    label: 'Naturalidade',
    value: 'naturalidade'
  },
  {
    label: 'Gêmeo',
    value: 'gemeo'
  },
  {
    label: 'Declarante (CPF e Nome)',
    value: 'declarante'
  },
  {
    label: 'Nome Genitor 1',
    value: 'nome_genitor_1'
  },
  {
    label: 'CPF Genitor 1',
    value: 'cpf_genitor_1'
  },
  {
    label: 'Nome Genitor 2',
    value: 'nome_genitor_2'
  },
  {
    label: 'CPF Genitor 2',
    value: 'cpf_genitor_2'
  }
]

export const casamento = [
  {
    label: 'CPF Cônjuge 1',
    value: 'cpf_conjuge_1'
  },
  {
    label: 'Sexo Cônjuge 1',
    value: 'sexo_conjuge_1'
  },
  {
    label: 'Data Nascimento Cônjuge 1',
    value: 'data_nascimento_conjuge_1'
  },
  {
    label: 'Estado civil Cônjuge 1',
    value: 'estado_civil_conjuge_1'
  },
  {
    label: 'Profissão Declarada Cônjuge 1',
    value: 'profissao_declarada_conjuge_1'
  },
  {
    label: 'Nacionalidade Cônjuge 1',
    value: 'nacionalidade_conjuge_1'
  },
  {
    label: 'Naturalidade (UF e cidade) Cônjuge 1',
    value: 'naturalidade_conjuge_1'
  },
  {
    label: 'Endereço Cônjuge 1',
    value: 'endereco_conjuge_1'
  },
  {
    label: 'Nome Genitor 1 Cônjuge 1',
    value: 'nome_genitor_1_conjuge_1'
  },
  {
    label: 'CPF Genitor 1 Cônjuge 1',
    value: 'cpf_genitor_1_conjuge_1'
  },
  {
    label: 'Nome Genitor 2 Cônjuge 1',
    value: 'nome_genitor_2_conjuge_1'
  },
  {
    label: 'CPF Genitor 2 Cônjuge 1',
    value: 'cpf_genitor_2_conjuge_1'
  },
  {
    label: 'Documento Cônjuge 1',
    value: 'documento_conjuge_1'
  },
  {
    label: 'CPF Cônjuge 2',
    value: 'cpf_conjuge_2'
  },
  {
    label: 'Sexo Cônjuge 2',
    value: 'sexo_conjuge_2'
  },
  {
    label: 'Data Nascimento Cônjuge 2',
    value: 'data_nascimento_conjuge_2'
  },
  {
    label: 'Estado civil Cônjuge 2',
    value: 'estado_civil_conjuge_2'
  },
  {
    label: 'Profissão Declarada Cônjuge 2',
    value: 'profissao_declarada_conjuge_2'
  },
  {
    label: 'Nacionalidade Cônjuge 2',
    value: 'nacionalidade_conjuge_2'
  },
  {
    label: 'Naturalidade (UF e cidade) Cônjuge 2',
    value: 'naturalidade_conjuge_2'
  },
  {
    label: 'Endereço Cônjuge 2',
    value: 'endereco_conjuge_2'
  },
  {
    label: 'Nome Genitor 1 Cônjuge 2',
    value: 'nome_genitor_1_conjuge_2'
  },
  {
    label: 'CPF Genitor 1 Cônjuge 2',
    value: 'cpf_genitor_1_conjuge_2'
  },
  {
    label: 'Nome Genitor 2 Cônjuge 2',
    value: 'nome_genitor_2_conjuge_2'
  },
  {
    label: 'CPF Genitor 2 Cônjuge 2',
    value: 'cpf_genitor_2_conjuge_2'
  },
  {
    label: 'Documento Cônjuge 2',
    value: 'documento_conjuge_2'
  },
  {
    label: 'Matrícula',
    value: 'matricula'
  },
  {
    label: 'Livro, folha, termo e lado do registro',
    value: 'livro',
    array: ['livro', 'folha', 'termo', 'lado']
  },
  {
    label: 'Data do Registro',
    value: 'data_registro',
  },
  {
    label: 'Local Publicação',
    value: 'local_publicacao',
  },
  {
    label: 'Data Publicação',
    value: 'data_publicacao',
  },
  {
    label: 'Data e Hora Casamento',
    value: 'data_hora_casamento',
  },
  {
    label: 'Juiz / Celebrante',
    value: 'juiz_celebrante',
  },
  {
    label: 'Regimento de Bens',
    value: 'regime_bens',
  },
  {
    label: 'Local de Casamento',
    value: 'local_casamento',
  },
  {
    label: 'Endereço Local de Casamento',
    value: 'endereco_casamento',
  },
  {
    label: 'Testemunhas',
    value: 'testemunhas',
  }
]
